import Messages from "@/pages/Messages";
export default function PartMessages() { return <Messages role="particulier" />; }
